import { render, staticRenderFns } from "./TotalEmployee.vue?vue&type=template&id=1c68b910"
import script from "./TotalEmployee.vue?vue&type=script&lang=js"
export * from "./TotalEmployee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports